export function SettingsHeader({ children }: { children: React.ReactNode }) {
  return (
    <div className="text-2xl font-medium mt-6 md:mt-12 mb-6">{children}</div>
  );
}
